import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_TEXT, CONTENT_CATEGORY_MODEL} from '../../constants';

export default {
  id: 'MOD_LIST_PERS',
  title: 'Un modèle de Liste du personnel ?',
  description: '',
  categories: [CONTENT_CATEGORY_MODEL],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Si vous souhaitez déposer une liste du personne, veuillez prendre le modèle suivant :'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: `${pathHelpContentFile}fr/FR_MOD_LIST_PERS/Liste personnel ok.xlsx`,
    label: 'Liste personnel.'
  }]
};
